"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//EXTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
let PermissionsService = class PermissionsService {
    constructor(_http) {
        this._http = _http;
        //initializations
        this.permissionURL = '/permission';
    }
    get() {
        return this.permissions;
    }
    pull(rowsLimit = 1000) {
        return this._http.get(`${this.permissionURL}?limit=${rowsLimit}`)
            .toPromise()
            .then(response => this.permissions = JSON.parse(response._body))
            .catch(console.error);
    }
};
exports.PermissionsService = PermissionsService;
exports.PermissionsService = PermissionsService = __decorate([
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [token_service_1.TokenService])
], PermissionsService);
//# sourceMappingURL=permissions.service.js.map